/*
  De Mani Jewelry — Homepage Snowfall
  - Loads only on the homepage (gated in layout/theme.liquid)
  - Respects prefers-reduced-motion
  - Non-interactive overlay (pointer-events: none)
*/

(function () {
  'use strict';

  if (window.__DM_SNOWFALL_INITIALIZED__) return;
  window.__DM_SNOWFALL_INITIALIZED__ = true;

  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) {}

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function rand(min, max) {
    return min + Math.random() * (max - min);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  var canvas = document.createElement('canvas');
  canvas.id = 'dm-snowfall-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText =
    'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999;';

  var append = function () {
    if (!document.body) return;
    if (document.getElementById(canvas.id)) return;
    document.body.appendChild(canvas);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', append, { once: true });
  } else {
    append();
  }

  var ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;

  var w = 0;
  var h = 0;
  var dpr = 1;

  var flakes = [];
  var sprites = [];

  function makeSpriteDot() {
    var c = document.createElement('canvas');
    c.width = 48;
    c.height = 48;
    var g = c.getContext('2d');
    g.fillStyle = '#ffffff';
    g.beginPath();
    g.arc(24, 24, 6, 0, Math.PI * 2);
    g.fill();
    return c;
  }

  function makeSpriteSnowflake(arms, withBranches) {
    var c = document.createElement('canvas');
    c.width = 64;
    c.height = 64;
    var g = c.getContext('2d');

    var cx = 32;
    var cy = 32;
    var r = 22;

    g.strokeStyle = '#ffffff';
    g.lineCap = 'round';
    g.lineWidth = 2;

    for (var i = 0; i < arms; i++) {
      var a = (Math.PI * 2 * i) / arms;
      var x1 = cx + Math.cos(a) * 4;
      var y1 = cy + Math.sin(a) * 4;
      var x2 = cx + Math.cos(a) * r;
      var y2 = cy + Math.sin(a) * r;

      g.beginPath();
      g.moveTo(x1, y1);
      g.lineTo(x2, y2);
      g.stroke();

      if (withBranches) {
        // Two small "branches" on each arm
        var bx = cx + Math.cos(a) * (r * 0.62);
        var by = cy + Math.sin(a) * (r * 0.62);

        var bLen = 7;
        var bAng = 0.55; // branch angle off main arm

        g.lineWidth = 1.6;
        g.beginPath();
        g.moveTo(bx, by);
        g.lineTo(bx + Math.cos(a + bAng) * bLen, by + Math.sin(a + bAng) * bLen);
        g.moveTo(bx, by);
        g.lineTo(bx + Math.cos(a - bAng) * bLen, by + Math.sin(a - bAng) * bLen);
        g.stroke();
        g.lineWidth = 2;
      }
    }

    // Subtle center dot
    g.fillStyle = '#ffffff';
    g.beginPath();
    g.arc(cx, cy, 2.2, 0, Math.PI * 2);
    g.fill();

    return c;
  }

  function makeSpriteHex() {
    var c = document.createElement('canvas');
    c.width = 64;
    c.height = 64;
    var g = c.getContext('2d');
    var cx = 32;
    var cy = 32;
    var r = 18;

    g.strokeStyle = '#ffffff';
    g.lineCap = 'round';
    g.lineWidth = 2;

    // Hexagon outline
    g.beginPath();
    for (var i = 0; i < 6; i++) {
      var a = (Math.PI * 2 * i) / 6 - Math.PI / 2;
      var x = cx + Math.cos(a) * r;
      var y = cy + Math.sin(a) * r;
      if (i === 0) g.moveTo(x, y);
      else g.lineTo(x, y);
    }
    g.closePath();
    g.stroke();

    // Inner spokes
    for (var j = 0; j < 6; j++) {
      var aj = (Math.PI * 2 * j) / 6 - Math.PI / 2;
      g.beginPath();
      g.moveTo(cx, cy);
      g.lineTo(cx + Math.cos(aj) * (r - 2), cy + Math.sin(aj) * (r - 2));
      g.stroke();
    }

    return c;
  }

  function buildSprites() {
    sprites = [
      makeSpriteSnowflake(6, true),
      makeSpriteSnowflake(8, false),
      makeSpriteHex(),
      makeSpriteDot(),
    ];
  }

  function resize() {
    w = Math.floor(window.innerWidth || document.documentElement.clientWidth || 0);
    h = Math.floor(window.innerHeight || document.documentElement.clientHeight || 0);
    dpr = clamp(window.devicePixelRatio || 1, 1, 2);
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function pickSprite(sizePx) {
    // Bigger flakes: more complex shapes; tiny flakes: dots
    if (sizePx <= 6) return 3; // dot
    var r = Math.random();
    if (r < 0.55) return 0; // 6-arm w/ branches
    if (r < 0.85) return 1; // 8-arm
    return 2; // hex
  }

  function makeFlake(init) {
    var isMobile = false;
    try {
      isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    } catch (e) {}

    // Size distribution: increase the upper bound for more varied, more "flake-like" snowfall.
    // (User requested ~3x upper limit)
    var size = rand(isMobile ? 5 : 6, isMobile ? 36 : 45);

    return {
      x: rand(0, w),
      y: init ? rand(0, h) : rand(-80, -10),
      size: size,
      vy: rand(0.6, 1.55) + size * 0.02,
      vx: rand(-0.15, 0.15),
      drift: rand(0.1, 0.9),
      phase: rand(0, Math.PI * 2),
      a: rand(0.35, 0.95),
      sprite: pickSprite(size),
      rot: rand(0, Math.PI * 2),
      rotSpeed: rand(-0.015, 0.015),
    };
  }

  function rebuildFlakes() {
    flakes = [];
    var isMobile = false;
    try {
      isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    } catch (e) {}

    // Density tuned to feel "holiday" but still minimal
    var density = (w * h) / 28000;
    var base = isMobile ? 32 : 55;
    var count = Math.round(clamp(Math.max(base, density), isMobile ? 22 : 40, 110));

    for (var i = 0; i < count; i++) flakes.push(makeFlake(true));
  }

  function drawFlake(f) {
    var sprite = sprites[f.sprite] || sprites[0];
    ctx.save();
    ctx.globalAlpha = f.a;
    ctx.translate(f.x, f.y);
    ctx.rotate(f.rot);
    var s = f.size;
    ctx.drawImage(sprite, -s / 2, -s / 2, s, s);
    ctx.restore();
  }

  var running = true;
  var last = (window.performance && performance.now) ? performance.now() : Date.now();

  function step(now) {
    if (!running) return;

    var tNow = (window.performance && performance.now) ? now : Date.now();
    var dt = Math.min(32, tNow - last);
    last = tNow;

    ctx.clearRect(0, 0, w, h);

    var wind = Math.sin(tNow * 0.0001) * 0.25;

    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];

      f.phase += 0.003 * dt;
      f.rot += f.rotSpeed * (dt / 16);

      f.x += (f.vx + wind + Math.sin(f.phase) * f.drift) * (dt / 16);
      f.y += f.vy * (dt / 16);

      if (f.x < -20) f.x = w + 20;
      if (f.x > w + 20) f.x = -20;

      if (f.y > h + 20) {
        f.x = rand(0, w);
        f.y = rand(-80, -10);
        var size = rand(5, (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) ? 36 : 45);
        f.size = size;
        f.vy = rand(0.6, 1.55) + size * 0.02;
        f.a = rand(0.35, 0.95);
        f.sprite = pickSprite(size);
        f.rot = rand(0, Math.PI * 2);
        f.rotSpeed = rand(-0.015, 0.015);
      }

      drawFlake(f);
    }

    requestAnimationFrame(step);
  }

  function onVisibilityChange() {
    running = !document.hidden;
    if (running) {
      last = (window.performance && performance.now) ? performance.now() : Date.now();
      requestAnimationFrame(step);
    }
  }

  buildSprites();
  resize();
  rebuildFlakes();

  window.addEventListener(
    'resize',
    debounce(function () {
      resize();
      rebuildFlakes();
    }, 150),
    { passive: true }
  );

  document.addEventListener('visibilitychange', onVisibilityChange);

  requestAnimationFrame(step);
})();
